const getBrowserNavigatorLocales = () => {
  const navigatorLanguages = navigator.languages;
  const navigatorLanguage = navigator.language;

  return navigatorLanguages ?? [navigatorLanguage];
};

export const GetBrowserLocale = () => {
  return getBrowserNavigatorLocales()[0];
};
